import { Button } from "@mui/material";
import React from "react";
import "./PageNotFound.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Error404 = () => {
  const navigate = useNavigate();
  const { systemRole } = useSelector((state) => state.Auth);
  const isFieldRecruiter = systemRole === "Field Recruiter";

  return (
    <div className="errorpage-section">
      <img
        src={process.env.PUBLIC_URL + "/assests/404Error.svg"}
        alt="404 error"
      />
      <h1>Oops!</h1>
      <p>
        This page isn't available. It may not exist, or you might not have
        access to it
      </p>
      <Button
        variant="contained"
        component="label"
        size="medium"
        onClick={(e) => {
          navigate(
            isFieldRecruiter
              ? "/ats/layout/applicants/list/landing"
              : "/ats/layout/dashboard",
          );
        }}
      >
        Go Back to Home
      </Button>
    </div>
  );
};

export default Error404;
